"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.tile {\n  border: 1px solid #e8e8e8;\n  margin-bottom: 1rem; }\n  .tile .tile-content {\n    padding: 1rem;\n    min-height: 116px; }\n    .tile .tile-content p {\n      font-size: 14px;\n      line-height: 1.43;\n      margin-bottom: 1.5rem; }\n    .tile .tile-content p.title {\n      color: #e41b13;\n      font-size: 20px;\n      margin-bottom: 1rem;\n      line-height: 1.3; }\n    .tile .tile-content p:last-child,\n    .tile .tile-content > div:last-child {\n      margin-bottom: 0; }\n  .tile .tile-button a {\n    background: #a8a8a8;\n    color: #fff;\n    padding: 1rem;\n    display: block;\n    text-decoration: none;\n    font-size: 14px; }\n    .tile .tile-button a:hover {\n      background: #4c4c4c; }\n";
  const fileName = "Tile_Tile";
  const element = document.querySelector("style[data-sass-component='Tile_Tile']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Tile = props => {
  const title = props.title ? /*#__PURE__*/_react.default.createElement("p", {
    className: "title"
  }, props.title) : null;
  const button = props.button ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'tile-button'
  }, props.button) : null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: 'tile'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'tile-content'
  }, title, props.children), button);
};
Tile.propTypes = {
  title: _propTypes.default.string,
  button: _propTypes.default.object
};
var _default = exports.default = Tile;